import React, {Component} from 'react';
import "./style.css"

class Collection extends Component {
    render() {
        return (
            <div className="collection">
                <h2>Collection</h2>
                <h1>NewLine</h1>
            </div>
        );
    }
}

export default Collection;